import React, { PureComponent } from 'react';

import EditCustomSale from './sale/edit-custom';

class Modals extends PureComponent {
  render() {
    return (
      <>
        <EditCustomSale />
      </>
    );
  }
}

export default Modals;
